import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  logisticDetails: null,
};

const viewLogisticSlice = createSlice({
  name: "viewLogistic",
  initialState,
  reducers: {
    fetchLogisticDetails(state, action) {
      state.loading = true;
    },
    fetchLogisticDetailsSuccess(state, action) {
      state.logisticDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchLogisticDetailsFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = viewLogisticSlice;
